import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { SVG_COMPONENTS } from '@/assets/admin';

const ThumbUpIcon = SVG_COMPONENTS.THUMB_UP;

/**
 * MobileMaintenanceEmptyState - Empty state component for maintenance screen
 * Matches Figma design with thumbs up icon and centered text
 */
export const MobileMaintenanceEmptyState: React.FC = () => {
  return (
    <View style={styles.container}>
      {/* Thumbs Up Icon */}
      <View style={styles.iconContainer}>
        <ThumbUpIcon width={68} height={68} color={MARKETPLACE_COLORS.inputBorder} />
      </View>
      
      {/* Text Content */}
      <View style={styles.textContainer}>
        <Text style={styles.title}>No service requests</Text>
        <Text style={styles.message}>
          You have no open service requests at the moment
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 40,
    paddingVertical: 65,
    gap: 18,
  },

  // Icon container
  iconContainer: {
    width: 68,
    height: 68,
    alignItems: 'center',
    justifyContent: 'center',
  },

  // Text
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 240,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 24,
    textAlign: 'center',
  },
  message: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textMuted,
    lineHeight: 21,
    textAlign: 'center',
  },
});

export default MobileMaintenanceEmptyState;
